import { NumberField } from '@/components/form/fields/text/NumberInput';
import { FunctionComponent } from 'react';

interface EmployeeCountFieldProps {
  readonly?: boolean;
}

const EmployeeCountField: FunctionComponent<EmployeeCountFieldProps> = ({ readonly }) => {
  return <NumberField readonly={readonly} min={1} id="companyInfo.employeeCount" label="Number of employees" />;
};

export default EmployeeCountField;
